<template>
	<div style="background-color: #fff">
		<Hrader ref="hreders"></Hrader>
		<div>
			<div style="height: 70px"></div>
			<div class="assets-left">
				<img src="@/assets/login-account/Mask group@2x.png" style="width: 100%; height: 552px" />
				<div class="account-content" v-if="1">
					<div class="captchaLogin">
						<div>
							<div class="platfor-title">找回密码</div>
							<div class="platfi-text" @click="haveAccount">
								已有账号？
								<span style="color: #ff3017">去登录</span>
							</div>
						</div>
					</div>
					<div v-if="ids == 3">
						<div class="mobile-bor">
							<img src="@/assets/Group 1268@2x.png" style="width: 11px; height: 16px; margin-left: 15px" />
							<input v-model="form.mobile" placeholder="手机号" class="input" />
						</div>
						<div class="mobile-bor" style="margin-top: 12px" v-if="!showNumber">
							<img src="@/assets/Group 1269@2x.png" style="width: 15px; height: 16px; margin-left: 15px" />
							<input v-model="form.code" placeholder="输入短信验证码" class="input" />
							<div class="mobile-flex" style="white-space: nowrap; color: #ff2f17" @click="SendCaptcha">发送验证码</div>
						</div>
						<div class="mobile-bor" style="margin-top: 12px" v-else>
							<img src="@/assets/Group 1269@2x.png" style="width: 15px; height: 16px; margin-left: 15px" />
							<input v-model="form.code" placeholder="输入短信验证码" class="input" />
							<div class="mobile-flex">{{ showNumber }}</div>
						</div>
						<div class="mobile-bor" style="margin-top: 12px">
							<img src="@/assets/Group 902@2x.png" style="width: 16px; height: 16px; margin-left: 15px" />
							<input v-model="form.password" type="password" placeholder="登录密码" class="input" />
						</div>
						<!-- <div class="mobile-bor" style="margin-top: 12px">
							<img src="@/assets/Group 902@2x.png" style="width: 16px; height: 16px; margin-left: 15px" />
							<input v-model="form.oldPassword" type="password" placeholder="确认登录密码" class="input" />
						</div> -->
					</div>
					<div class="login" @click="clickLogin">登录</div>
				</div>
			</div>
			<MoreWidth></MoreWidth>
		</div>
		<Tabr></Tabr>
		<Verify
			mode="pop"
			@success="handleSuccess"
			:captchaType="captchaType"
			:imgSize="{ width: '400px', height: '200px' }"
			ref="verify"
		></Verify>
	</div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import Hrader from '@/components/header.vue';
import MoreWidth from '@/components/moreWidth.vue';
import Tabr from '@/components/tabrButton.vue';
import Verify from '@/components/verifition/Verify';
import { sendSmsCode, memberUserGet, configUserProtocolDAta, updatePasswordBySms, updatePassword } from '@/utils/api.js';
import { ElMessage } from 'element-plus';
const dialogVisible1 = ref(false);
const dialogVisible2 = ref(false);
let form = ref({});
let text = ref('');
let title = ref('服务协议');
let idsTar = ref(1);
let textTile = ref('');
let checked = ref(false);
let ids = ref(3);
let showNumber = ref(0);
const verify = ref(null);
const captchaType = ref('blockPuzzle');
const register = () => {
	console.log(111);
};
onMounted(() => {
	window.scrollTo(0, 0);
	infoScrotop();
});

const infoScrotop = () => {
	configUserProtocolDAta('user_protocol_html').then((res) => {
		console.log(res.data.value);
		text.value = res.data.value;
	});
	configUserProtocolDAta('privacy_protocol_html').then((res) => {
		console.log(res.data.value);
		textTile.value = res.data.value;
	});
};

const SendCaptcha = () => {
	if (showNumber.value != 0) return false;
	const phoneRegex = /^1[3-9]\d{9}$/;
	if (!form.value.mobile) {
		ElMessage({
			message: '手机号不能为空',
			type: 'error',
		});
		return false;
	}
	if (!phoneRegex.test(form.value.mobile)) {
		ElMessage({
			message: '手机号格式不正确',
			type: 'error',
		});
		return false;
	}
	verify.value.show();
};

const sendSmsCodeClick = async (captchaVerification) => {
	const data = await sendSmsCode({
		mobile: form.value.mobile,
		scene: 1,
		captchaVerification,
	});
	if (data.code === 0) {
		showNumber.value = 60;
		infoNumber();
	} else {
		ElMessage({
			message: data.msg || '发送失败',
			type: 'error',
		});
	}
};

const handleSuccess = (res) => {
	sendSmsCodeClick(res.captchaVerification);
};

const clickLogin = async () => {
	const phoneRegex = /^1[3-9]\d{9}$/;
	const regex = /^(?=.*[A-Za-z])(?=.*\d).{6,18}$/;
	if (!regex.test(form.value.password)) {
		ElMessage({
			message: '密码（6-18位）必须包含数字和字母',
			type: 'error'
		});
		return false;
	}
	if (!form.value.mobile) {
		ElMessage({
			message: '手机号不能为空',
			type: 'error'
		});
		return false;
	}
	if (!phoneRegex.test(form.value.mobile)) {
		ElMessage({
			message: '手机号格式正确',
			type: 'error'
		});
		return false;
	}
	if (!form.value.code) {
		ElMessage({
			message: '请输入验证码',
			type: 'error'
		});
		return false;
	}

	if (!form.value.password) {
		ElMessage({
			message: '请输入密码',
			type: 'error'
		});
		return false;
	}

	const res = await updatePasswordBySms({
		fromProxyId: '',
		mobile: form.value.mobile,
		code: form.value.code,
		password: form.value.password
	});
	if (res.msg) {
		ElMessage({
			message: res.msg,
			type: 'error'
		});
	} else {
		ElMessage({
			message: '修改成功',
			type: 'success'
		});
		window.history.go(-1);
	}
};

const infoUpdatePassword = async () => {
	let res = await updatePassword({
		password: form.value.password,
		oldPassword: form.value.oldPassword
	});
	if (res.msg) {
		ElMessage({
			message: res.msg,
			type: 'error'
		});
	} else {
		ElMessage({
			message: '修改成功',
			type: 'success'
		});
		window.history.go(-1);
	}
};

const haveAccount = () => {
	history.go(-1);
};

const infoatin = async () => {
	let res = await memberUserGet();
	localStorage.setItem('information', JSON.stringify(res.data));
	ElMessage({
		message: '登陆成功',
		type: 'success'
	});
	window.history.go(-1);
};
const infoNumber = () => {
	setTimeout(() => {
		if (showNumber.value) {
			showNumber.value = showNumber.value - 1;
			infoNumber();
		}
	}, 1000);
};
const protocolClick = (item) => {
	if (item == 1) {
		dialogVisible1.value = true;
	} else {
		dialogVisible2.value = true;
	}
};
const clickJump = (index) => {
	ids.value = index;
};
</script>

<style lang="scss" scoped>
.assets-left {
	position: relative;
	width: 100%;
	z-index: 1;
	height: 552px;
}
.account-content {
	width: 390px;
	// height: 329px;
	padding-bottom: 15px;
	background: #ffffff;
	box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.04);
	border-radius: 4px 4px 4px 4px;
	position: absolute;
	top: 140px;
	right: 258px;
}
.captchaLogin {
	display: flex;
	align-items: flex-start;
	justify-content: center;
	margin-top: 20px;
}

.captchaLogin:hover {
	cursor: pointer;
}

.mobile-title1 {
	color: #ff2f17;
}
.mobile {
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
}
.bor-top {
	width: 26px;
	height: 4px;
	background: #ff2f17;
	border-radius: 6px 6px 6px 6px;
	margin-top: 4px;
}

.mobile-bor {
	width: 320px;
	height: 42px;
	background: #ffffff;
	border-radius: 4px 4px 4px 4px;
	border: 1px solid #eeeeee;
	display: flex;
	align-items: center;
	margin: auto;
	margin-top: 22px;
}
.mobile-bor1 {
	display: flex;
	align-items: center;
	justify-content: center;
	margin: auto;
	margin-top: 40px;
}

.input {
	border: none;
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 16px;
	color: #000;
	font-style: normal;
	text-transform: none;
	margin-left: 10px;
}
.input::placeholder {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 16px;
	color: #aaaaaa;
	font-style: normal;
	text-transform: none;
}
input:focus {
	outline: none;
	border: none;
}
.login {
	width: 320px;
	height: 42px;
	background: #ff2f17;
	border-radius: 7px;
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 16px;
	color: #ffffff;
	line-height: 42px;
	text-align: center;
	font-style: normal;
	text-transform: none;
	margin: auto;
	margin-top: 12px;
}

.login:hover {
	cursor: pointer;
}

.register {
	text-align: center;
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 16px;
	margin-top: 10px;
	color: blue;
}

.register:hover {
	cursor: pointer;
}

.account-content1 {
	width: 390px;
	background: #ffffff;
	border-radius: 7px;
	position: relative;
	padding-bottom: 10px;
	position: absolute;
	top: 18px;
	right: 258px;
	position: absolute;
}

.registered {
	font-family: PingFang SC, PingFang SC;
	font-weight: 600;
	font-size: 22px;
	color: #333333;
	font-style: normal;
	text-transform: none;
	margin-left: 57px;
	margin-top: 30px;
}
.registered-text {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 13px;
	color: #333333;
	letter-spacing: 3px;
	font-style: normal;
	text-transform: none;
	margin-left: 57px;
	margin-top: 7px;
}
.have-read {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 12px;
	color: #333333;
	font-style: normal;
	text-transform: none;
	padding-left: 7px;
}
.have-read:hover {
	cursor: pointer;
}

.flex-pws {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 12px;
	color: #ff2f17;
	text-align: center;
	font-style: normal;
	text-transform: none;
	margin-top: 7px;
}

.flex-pws:hover {
	cursor: pointer;
}

.mobile-flex {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #ff2f17;
	text-align: left;
	font-style: normal;
	text-transform: none;
	margin-left: auto;
	margin-right: 20px;
}
.mobile-flex:hover {
	cursor: pointer;
}

.title-text {
	text-align: center;
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #aeaeac;
	text-align: left;
	font-style: normal;
	text-align: center;
	margin-top: 10px;
	text-transform: none;
}

.registerArkey {
	width: 350px;
	text-align: right;
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	margin-top: 3px;
	color: #000;
}
.registerArkey:hover {
	cursor: pointer;
}

.platfor-title {
	font-family: PingFang SC, PingFang SC;
	font-weight: 600;
	font-size: 26px;
	color: #333333;
	text-align: center;
	font-style: normal;
	text-transform: none;
}

.platfi-text {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	text-align: center;
	font-style: normal;
	text-transform: none;
}
</style>
